import React from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import moment from 'moment'
import * as R from 'ramda'
import { Typography } from '@material-ui/core'
import { formatCpfCnpj } from '../../../utils/Formatter'

export default function ViagensList({ viagens = [], detalhesMotorista }) {
  const sortByDate = R.sortWith([
    R.descend(R.prop('data')),
    R.descend(R.prop('id'))
  ])
  viagens = sortByDate(viagens)
  return viagens && viagens.length ? (
    <TableContainer>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Data</TableCell>
            <TableCell>Empresa</TableCell>
            <TableCell>Origem</TableCell>
            <TableCell>Destino</TableCell>
            <TableCell>Produto</TableCell>
            <TableCell>Valor</TableCell>
            {detalhesMotorista && (
              <>
                <TableCell>Composicao</TableCell>
                <TableCell>Proprietario</TableCell>
              </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {viagens.map(viagem => (
            <TableRow key={viagem.id}>
              <TableCell>
                {moment(viagem.data).format('DD/MM/YYYY HH:mm')}
              </TableCell>
              <TableCell>{viagem.empresa?.sigla}</TableCell>
              <TableCell>{viagem.origem}</TableCell>
              <TableCell>{viagem.destino}</TableCell>
              <TableCell>{viagem.produto}</TableCell>
              <TableCell>
                {(+viagem.valor).toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                  style: 'currency',
                  currency: 'BRL'
                })}
              </TableCell>
              {detalhesMotorista && (
                <>
                  <TableCell>{viagem.composicao}</TableCell>
                  <TableCell>
                    {viagem.nomeProprietario &&
                    typeof viagem.nomeProprietario === 'object'
                      ? viagem.nomeProprietario.NOME ||
                        formatCpfCnpj(viagem.nomeProprietario.CPFCNPJ) ||
                        ''
                      : viagem.nomeProprietario}
                  </TableCell>
                </>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <Typography>Não foram encontradas viagens</Typography>
  )
}
